export const DEFAULT_KEY_ACTION_MAPPING = new Map();
DEFAULT_KEY_ACTION_MAPPING.set(0, "toggleToolViewer");
